module.exports = __webpack_public_path__ + "img/work-2.7e71126f.png";